import { render, staticRenderFns } from "./choseDefaultThem.vue?vue&type=template&id=2de07b1a&scoped=true"
import script from "./choseDefaultThem.vue?vue&type=script&lang=js"
export * from "./choseDefaultThem.vue?vue&type=script&lang=js"
import style0 from "./choseDefaultThem.vue?vue&type=style&index=0&id=2de07b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de07b1a",
  null
  
)

export default component.exports